import { __rest, __assign } from 'tslib';
import classNames from 'classnames';
import { createElement } from 'react';
import { useIconStyles } from './IconStyles.js';

var iconStaticClassName = 'pop-icon';
var Icon = function (props) {
    var icon = props.icon, className = props.className, restProps = __rest(props, ["icon", "className"]);
    var hasAccessibleAttr = Boolean(restProps['aria-describedby'] || restProps['aria-label']);
    if (!hasAccessibleAttr && restProps['aria-hidden'] === undefined) {
        restProps['aria-hidden'] = true;
    }
    var classes = useIconStyles(props);
    var isValid = true;
    if (!icon || (typeof icon === 'function' && icon({}) === undefined)) {
        isValid = false;
    }
    return isValid
        ? createElement(icon, __assign({ className: classNames([classes.root, iconStaticClassName, className]), width: undefined, height: undefined }, restProps))
        : null;
};
Icon.defaultProps = {
    size: 'inherit',
    color: 'inherit',
};
Icon.displayName = 'Icon';

export { Icon, iconStaticClassName };
//# sourceMappingURL=Icon.js.map
